var map = {
	"./Allegory of woe.webp": "afe4",
	"./Dormant volcano - Village of Harz.webp": "fc9d",
	"./Folie à deux.webp": "968d",
	"./Gorb baron 1.webp": "8121",
	"./Gorb baron 2.webp": "3d45",
	"./Karon.webp": "cc95",
	"./Quand c’est.webp": "5c2a",
	"./Sphinx riddle.webp": "b89d",
	"./The ethereal peregrination.webp": "1bf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "effe";